<template>
    <v-data-iterator
        v-bind="$attrs"
        class="base-data-grid"
        :footer-props="{ itemsPerPageOptions }"
        :hide-default-footer="footerSlotInUse"
        :items-per-page="itemsPerPage"
        must-sort
    >
        <template
            v-if="$slots.toolbar || $scopedSlots.toolbar"
            v-slot:header="slotProps"
        >
            <v-row>
                 <v-col class="base-data-grid__toolbar d-flex justify-center align-center">
                    <slot
                        v-bind="slotProps"
                        name="toolbar"
                    />
                </v-col>
            </v-row>
        </template>

        <template v-slot:loading>
            <v-row>
                <v-col class="base-data-grid__loading d-flex justify-center align-center">
                    <slot
                        v-if="$slots.loading"
                        name="loading"
                    />

                    <template v-else>
                        <v-progress-circular
                            color="primary"
                            indeterminate
                            size="64"
                            width="8"
                        />
                    </template>
                </v-col>
            </v-row>
        </template>

        <template v-slot:no-data>
            <v-row>
                <v-col class="base-data-grid__no-data d-flex justify-center align-center">
                    <slot
                        v-if="$slots['no-data']"
                        name="no-data"
                    />

                    <template v-else>
                        <v-alert
                            class="px-12"
                            text
                        >
                            {{ $vuetify.noDataText }}
                        </v-alert>
                    </template>
                </v-col>
            </v-row>
        </template>

        <template v-slot:no-results>
            <v-row>
                <v-col class="base-data-grid__no-results d-flex justify-center align-center">
                    <slot
                        v-if="$slots['no-results']"
                        name="no-results"
                    />

                    <template v-else>
                        <v-alert
                            class="px-12"
                            text
                        >
                            {{ $vuetify.dataIterator.noResultsText }}
                        </v-alert>
                    </template>
                </v-col>
            </v-row>
        </template>

        <template v-slot:default="slotProps">
            <v-row
                v-if="slotProps && slotProps.items && slotProps.items.length"
                class="base-data-grid__items-row"
            >
                <v-col
                    v-for="item in slotProps.items"
                    :key="item[$attrs.itemKey]"
                    v-bind="itemVColProps"
                    class="base-data-grid__items-col"
                >
                    <slot
                        v-bind="item"
                        name="item"
                    />
                </v-col>
            </v-row>
        </template>

        <template
            v-if="$slots.footer || $scopedSlots.footer"
            v-slot:footer="slotProps"
        >
            <v-row>
                 <v-col class="base-data-grid__footer d-flex justify-center align-center">
                    <slot
                        v-bind="slotProps"
                        name="footer"
                    />
                </v-col>
            </v-row>
        </template>
    </v-data-iterator>
</template>

<script>
export const DEFAULT_COL_CONFIG = {
    cols: "12",
    sm: "6",
    md: "4",
    lg: "3",
    xl: "2",
};

const PER_PAGE_ALL = -1;

export default {
    name: "BaseDataGrid",

    props: {
        itemsPerPage: {
            type: Number,
            default: 12,
        },

        /**
         * Allows passing `props` to the `<v-col>` surrounding each item slot.
         */
        itemVColProps: {
            type: Object,

            default() {
                return {
                    ...DEFAULT_COL_CONFIG,
                };
            },
        },
    },

    data() {
        return {
            itemsPerPageOptions: [
                12,
                24,
                48,
                PER_PAGE_ALL,
            ],
        };
    },

    computed: {
        footerSlotInUse() {
            return !!this.$slots.footer || !!this.$scopedSlots.footer;
        },
    },
};
</script>
